// External Dependencies
import Vue from 'vue';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

if ( import.meta.env.PROD ) {
    Sentry.init({
        environment: import.meta.env.VITE_APP_ENV,
        dsn: import.meta.env.VITE_SENTRY_LARAVEL_DSN,

        /** @see https://docs.sentry.io/platforms/javascript/configuration/options/#ignoreErrors */
        ignoreErrors: [
            // module preload errors
            /TypeError:.+is undefined/,

            // stale chunk load errors
            /__esModule/,
            /dynamically imported module/,
            /Importing a module script failed/,
        ],

        // Rate limited requests are reported once by the AuthInterceptor
        beforeSend(event, hint) {
            const status = hint?.originalException?.status ?? hint?.originalException?.response?.status;

            if ( status === 429 ) {
                return null;
            }

            return event;
        },

        integrations: [
            new Integrations.Vue({
                Vue,
                attachProps: true,
            }),
        ],
    });
}


import KickStart from 'kickstart-ui';
import VueMask from 'v-mask';

// Internal Dependencies
import refresher from './helpers/refresher';
import {userCan, userCanGroup} from './helpers/permissions';

window.user_acted = false;
window.refreshing_token = false;

Vue.use(KickStart);
Vue.api.baseUrl(import.meta.env.VITE_API_URL);
Vue.use(VueMask);
Vue.prototype.$userCan = userCan;
Vue.prototype.$userCanGroup = userCanGroup;

import { initializeInterceptors } from './helpers/interceptors';
initializeInterceptors(Vue);

import './helpers/filters';
import './helpers/directives';

// Setup global components
import './Vault/UI';

// Watch for user actions and ping server to keep session active
// CSRF token is only generated for auth users, so we can use it
// to ensure refresher() only fires for logged-in users.
if ( document.head.querySelector('meta[name="csrf-token"]')?.content ) {
    refresher();
}
